import { state, style, trigger, animate, transition } from '@angular/animations'

export let slideRight = trigger('slideRight', [
    state('void', style({opacity: 0, transform: 'translateX(-100%) rotateX(180deg)'})),
    transition('void => *', [
        animate(700)
    ])
]);

export let slideUp = trigger('slideUp', [
    state('void', style({opacity: 0, transform: 'translateY(200%)'})),
    transition('void => *', [
        animate(700)
    ])
]);

export let slideDown = trigger('slideDown', [
    state('void', style({opacity: 0, transform: 'translateY(-50%)'})),
    transition('void => *', [
        animate(200)
    ])
])


export let fade = trigger('fade', [
    state('void', style({opacity: 0})),
    transition(':enter', [
        animate(2000)
    ])
]);

export let popUp = trigger('popUp', [
    state('show', style({display: 'block', opacity: 1})),
    state('hide', style({display: 'none', opacity: 0})),
    transition('hide => show', [
        animate('600ms ease-in')
    ]),
    transition('show => hide', [
        animate('600ms ease-out')
    ])
]);
